function variantScrollRight(lastItem) {
  const element = document.getElementById(lastItem);
  element.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
}

function variantScrollLeft(firstItem) {
  const element = document.getElementById(firstItem);
  element.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
}

function buttonOff(button) {
  const element = document.getElementById(button);
  console.log (element);
  element.classList.add("disabled");
}

function buttonOn(button) {
  const element = document.getElementById(button);
  console.log (element);
  element.classList.remove("disabled");
}